import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LogoMark } from "@/components/Logo";

export const LegalLayout = ({ title, children }) => (
  <div className="min-h-screen bg-obsidian px-5 py-16 sm:py-20 grain">
    <div className="max-w-3xl mx-auto">
      <Link
        to="/"
        data-testid="legal-back-link"
        className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-gold transition-colors"
      >
        <ArrowLeft className="w-4 h-4" /> All In Hand Marketing
      </Link>
      <div className="mt-10 rounded-3xl border border-slate-700/60 bg-obsidian-800/50 p-7 sm:p-12">
        <LogoMark className="w-12 h-12" />
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-white mt-6">{title}</h1>
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500 mt-3">
          All In Hand Marketing · allinhandmarketing.com
        </p>
        <div className="mt-10 space-y-6 text-slate-300 leading-relaxed text-sm sm:text-base">
          {children}
        </div>
      </div>
      <p className="text-slate-600 text-xs text-center mt-10">
        © All In Hand Marketing. All rights reserved.
      </p>
    </div>
  </div>
);

export default LegalLayout;
